import "@/App.css";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import { Toaster } from "sonner";
import { AuthProvider, useAuth } from "@/context/AuthContext";
import Layout from "@/components/app/Layout";
import Landing from "@/pages/Landing";
import Login from "@/pages/Login";
import Register from "@/pages/Register";
import CombinedID from "@/pages/CombinedID";
import PhotoID from "@/pages/PhotoID";
import VinDecoder from "@/pages/VinDecoder";
import TagDecoder from "@/pages/TagDecoder";
import Garage from "@/pages/Garage";

const Protected = ({ children }) => {
  const { user, loading } = useAuth();
  if (loading) return (
    <div className="min-h-[60vh] flex items-center justify-center">
      <div className="font-mono text-xs uppercase tracking-widest text-amber-brass">Booting workshop…</div>
    </div>
  );
  if (!user) return <Navigate to="/login" replace />;
  return children;
};

function App() {
  return (
    <div className="App">
      <AuthProvider>
        <BrowserRouter>
          <Layout>
            <Routes>
              <Route path="/" element={<Landing />} />
              <Route path="/login" element={<Login />} />
              <Route path="/register" element={<Register />} />
              <Route path="/identify" element={<Protected><CombinedID /></Protected>} />
              <Route path="/photo" element={<Protected><PhotoID /></Protected>} />
              <Route path="/vin" element={<Protected><VinDecoder /></Protected>} />
              <Route path="/tag" element={<Protected><TagDecoder /></Protected>} />
              <Route path="/garage" element={<Protected><Garage /></Protected>} />
              <Route path="*" element={<Navigate to="/" replace />} />
            </Routes>
          </Layout>
        </BrowserRouter>
        <Toaster theme="dark" position="top-right" richColors />
      </AuthProvider>
    </div>
  );
}

export default App;
